$( document ).ready(function() {
    $('#parent-parent_1_date_of_birth-picker').datetimepicker({
        viewMode: 'years',
        viewDate: moment().subtract(20, 'years'),
        maxDate: moment(),
        useCurrent: false,
        format: 'MM/DD/YYYY'
    });
    $('#parent-parent_2_date_of_birth-picker').datetimepicker({
        viewMode: 'years',
        viewDate: moment().subtract(20, 'years'),
        maxDate: moment(),
        useCurrent: false,
        format: 'MM/DD/YYYY'
    });
});
